import { createCanBoundTo } from '@casl/react';
import { ability } from 'config/ability';

export { ability };
export default createCanBoundTo(ability);
